__turbopack_context__.v({
  "dot": "NecessaryDocuments-module-scss-module__qtpG4G__dot",
  "necessary-documents": "NecessaryDocuments-module-scss-module__qtpG4G__necessary-documents",
  "necessary-item": "NecessaryDocuments-module-scss-module__qtpG4G__necessary-item",
  "necessary-list": "NecessaryDocuments-module-scss-module__qtpG4G__necessary-list",
  "necessary-title-wrapper": "NecessaryDocuments-module-scss-module__qtpG4G__necessary-title-wrapper",
});
